// extracted by mini-css-extract-plugin
module.exports = {"notFoundError":"my-organizations_notFoundError__tNN0R"};